<template src="./listaPreventivi.html"></template>

<script>
import {
  get_listaPreventivi,
  del_preventivo,
  set_testata,
  stampa_Preventivo,
} from "@/api/api.preventivi.js";
import { get_profiloUtente } from "@/api/api.user.js";

export default {
  data: () => ({
    page: 1,
    pageCount: 0,
    itemsPerPage: 999,

    giorni: 30,
    headers: [
      { text: "Numero", align: "right", value: "NumPrev", sortable: false },
      {
        text: "Riferimento",
        align: "left",
        value: "RifCliente",
        sortable: false,
      },
      { text: "Data", align: "left", value: "Data", sortable: false },
      {
        text: "Data Modifica",
        align: "left",
        value: "dataModifica",
        sortable: false,
      },
      { text: "Importo", align: "left", value: "Importo", sortable: false },
      { text: "", value: "next", sortable: false },
      /* { text: "", align: "center", value: "empty", sortable: false }, */
    ],
    selectedRow: [],
    dati: [{ NumPrev: "" }],
    search: "",
    pagination: {
      sortBy: "dataModifica",
      rowsPerPage: 50,
      descending: true,
    },

    dataOggi: "",
    filtro: "",
    elencoGiorni: [30, 60, 90, "Tutti"],
    riferimento: "",
    dialogNew: false,
    datiUtente: {},

    smartphone: false,

    sortBy: 'Numero',
    sortDesc: false,
  }),

  methods: {
    async caricaDati() {
      await this.caricaDatiProfilo();
      if (this.giorni != this.$store.getters["app/getFiltroGiorni"])
        this.$store.commit("app/SET_FILTROGIORNI", this.giorni);
      this.dati = [];
      let res = await get_listaPreventivi(
        this.giorni == "Tutti" ? 0 : this.giorni,
        this.datiUtente.IdUtente
      );
      this.dati = res.data;
    },

    refresh() {
      this.caricaDati();
      this.$store.commit("app/SET_REFRESHDATI", false);
    },

    clickRow(props) {
      this.selectedRow = props;
    },

    dettaglioPreve(num) {
      if (num == 0 || num == undefined) {
        this.$toast.warning("Nessun preventivo selezionato");
        return;
      }
      this.$store.commit("app/SET_NUMPREVE", num);

      this.$router.push({ path: "/preventivo" });
    },

    /* changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    }, */

    changeSort(column) {
      // Se la colonna cliccata è già quella di ordinamento, cambia la direzione
      if (this.sortBy === column) {
        this.sortDesc = !this.sortDesc;
      } else {
        // Altrimenti, imposta la colonna di ordinamento e la direzione ascendente
        this.sortBy = column;
        this.sortDesc = false;
      }
    },


    //PREVENTIVI
    nuovoOrdine() {
      //this.$refs.rifer.focus();
      this.dialogNew = true;
    },

    salva() {
      if (this.riferimento != "" && this.riferimento != null) {
        this.creaOrdine();
        this.dialogNew = false;
      } else {
        this.$toast.warning("Nessun riferimento inserito");
      }
    },

    async creaOrdine() {
      let stringaDati = {
        id: 0,
        data: this.dataOggi,
        dataModifica: this.dataOggi,
        idUtente: this.datiUtente.IdUtente,
        codCliente: this.datiUtente.Codice,
        rifCliente: this.riferimento,
        note: "",
        sconto: 0,
        collezione: "Speedy",
      };
      //agiungere controlli su utente e cliente
      let res = await set_testata(stringaDati);
      if (res.data.isNull || res.data.isNaN || res.data == 0)
        this.$toast.error("errore creazione preventivo");
      this.refresh();
    },

    controllaNumero() {
      if (!!this.selectedRow.Id == false) {
        this.$toast.warning("Nessun preventivo selezionato");
        return false;
      }
      return true;
    },

    async eliminaPreventivo() {
      if (!this.controllaNumero()) return;
      let confirm = await this.$root.$confirm(
        "Elimina",
        "Vuoi eliminare il preventivo ?"
      );
      if (!confirm) return;
      // Attesa
      this.$root.$wait.open();
      let res = await del_preventivo(this.selectedRow.Id);
      // Pulizia
      if (res.data == "OK") {
        this.$toast.warning("Preventivo eliminato");
      }
      this.refresh();
      this.riferimento = "";
      this.$root.$wait.close();
    },

    async stampaOrdine() {
      if (!this.controllaNumero()) return;
      let res = await stampa_Preventivo(this.selectedRow.Id);
      this.$i2kFunctions.createBlobPdf(res.data);
    },

    async caricaDatiProfilo() {
      let par = "";
      let userSwitch = this.$store.getters["user/getUserSwitch"];
      if (userSwitch.Codice) par = userSwitch.Tipo + "/" + userSwitch.Codice;
      let res = await get_profiloUtente(par);
      this.datiUtente = res.data.Profilo;
    },

    cliccaRigo(id) {
      if (this.$i2kFunctions.isMobile()) this.dettaglioPreve(id);
    },
  },

  async mounted() {
    this.smartphone = this.$i2kFunctions.isSmartphone();
    await this.caricaDatiProfilo();
    await this.caricaDati();
  },

  created() {
    this.dataOggi = this.$i2kFunctions.formatDate_IT(new Date());
    this.$store.commit("app/SET_PAGEPREVE", "/preventivi");
    this.giorni = this.$store.getters["app/getFiltroGiorni"];
  },

  computed: {
    getRefreshDati() {
      return this.$store.getters["app/getRefreshDati"];
    },
  },

  watch: {
    getRefreshDati(newVal) {
      if (newVal != true) return;
      this.refresh();
    },
  },
};
</script>
<style scoped src="../../assets/styles/preventivo.css"></style>